export const s3BucketNames = {
	pdfBucket: "pdf-bike-bucket"
}
